import { render, staticRenderFns } from "./TraceCenterPage.vue?vue&type=template&id=70657fd6&scoped=true&"
import script from "./TraceCenterPage.vue?vue&type=script&lang=js&"
export * from "./TraceCenterPage.vue?vue&type=script&lang=js&"
import style0 from "./TraceCenterPage.vue?vue&type=style&index=0&id=70657fd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70657fd6",
  null
  
)

export default component.exports